// components/ScrollToTop/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll the main content area to top
    const mainContent = document.querySelector("[data-scroll-container]");
    if (mainContent) {
      mainContent.scrollTo(0, 0);
    }
    // Also scroll window as fallback
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
